<!-- TODO GESTION DES SWAL -->

<template>
    <div id="login" class="relative bg-white min-h-screen overflow-hidden font-sans">
        <!-- Vague FIXÉE en bas -->
        <div class="fixed inset-x-0 bottom-0 z-0 h-56 md:h-72 pointer-events-none">
            <svg class="w-full h-full text-secondary opacity-30" viewBox="0 0 1440 480" fill="currentColor"
                preserveAspectRatio="none">
                <path d="M0,140 C400,320 800,100 1440,280 L1440,480 L0,480Z" />
            </svg>
        </div>

        <!-- Contenu principal (avec padding bas pour ne pas passer sous le footer) -->
        <div class="relative z-10 flex flex-col items-center min-h-screen pt-10">
            <div class="w-full max-w-xs md:max-w-md lg:max-w-lg ">
                <!-- Logo -->
                <div class="h-32 md:56 bg-no-repeat bg-center bg-contain mb-4"
                    :style="{ backgroundImage: `url(${require('../../img/logo-fi360-nomadia.svg')})` }">
                </div>

                <!-- Form -->
                <div class="pb-4 relative z-10">
                    <form id="loginform" class="space-y-4" @submit="tryLogin">
                        <!-- Email -->
                        <div
                            class="w-full h-14 md:h-16 flex items-center rounded-lg border border-solid border-gray-400 bg-white pl-3 pr-2 focus-within:border-secondary box-border">
                            <i class="inline-block h-6 w-6 mask mask-user-gear bg-gray-400 flex-shrink-0"></i>
                            <input type="email" id="email" v-model="email" name="login" placeholder="Adresse Email"
                                autocomplete="on" class="flex-1 h-full bg-transparent px-3
           text-gray-900 placeholder-gray-400 text-base md:text-xl
           border-0 outline-none appearance-none box-border" />
                        </div>

                        <!-- Password -->
                        <div
                            class="w-full h-14 md:h-16 mt-3 flex items-center rounded-lg border border-solid border-gray-400 bg-white pl-3 pr-2 focus-within:border-secondary box-border">
                            <i class="inline-block h-6 w-6 mask mask-lock bg-gray-400 flex-shrink-0"></i>
                            <input type="password" id="password" v-model="password" name="pwd"
                                placeholder="Mot de passe" autocomplete="on" class="flex-1 h-full bg-transparent px-3
           text-gray-900 placeholder-gray-400 text-base md:text-xl
           border-0 outline-none appearance-none box-border" />
                        </div>

                        <!-- Connexion -->
                        <div class="mt-4 flex space-x-2">
                            <input type="submit" name="submit" value="Connexion"
                                class="w-full h-14 md:h-16 text-center bg-primary text-white font-semibold rounded-lg hover:bg-primary-hover transition-colors text-base md:text-xl flex items-center justify-center no-underline appearance-none border-none outline-none shadow-none" />

                            <button v-if="isMobile()" @click.prevent="launchAuth()"
                                class="w-full h-14 md:h-16 text-center bg-primary text-white font-semibold rounded-lg hover:bg-primary-hover transition-colors text-base md:text-xl flex items-center justify-center no-underline appearance-none border-none outline-none shadow-none">
                                <i class="inline-block h-5 w-5 mask mask-biometric mr-2 bg-white"></i>
                                Biométrie
                            </button>
                        </div>
                    </form>
                </div>

                <!-- Liens secondaires (même largeur que le form) -->
                <div class="space-y-2">
                    <a href="https://admin.fi360.fr/resetting/request" id="forget-pwd"
                        class="w-full h-14 md:h-16 text-center bg-primary text-white font-semibold rounded-lg hover:bg-primary-hover transition-colors text-base md:text-xl flex items-center justify-center no-underline shadow-sm">
                        Mot de passe oublié
                    </a>

                    <a href="javascript:void(0)" @click.prevent="updateFront"
                        class="w-full h-14 md:h-16 text-center bg-primary text-white font-semibold rounded-lg hover:bg-primary-hover transition-colors text-base md:text-xl flex items-center justify-center no-underline shadow-sm">
                        Mettre à jour
                    </a>

                    <a :href="urlSSO"
                        class="w-full h-14 md:h-16 text-center bg-primary text-white font-semibold rounded-lg hover:bg-primary-hover transition-colors text-base md:text-xl flex items-center justify-center no-underline shadow-sm">
                        Connexion réservée SSO
                    </a>
                </div>

                <!-- Lien “VIDER MES DONNÉES LOCALES” dans le flux -->
                <div class="relative z-10 mt-4 flex justify-center"
                    style="padding-bottom: env(safe-area-inset-bottom);">
                    <a href="#"
                        class="inline-flex items-center justify-center py-6 text-alert font-bold text-sm md:text-lg uppercase no-underline"
                        @click.prevent="clearCache">
                        <i class="inline-block h-6 w-6 mask mask-trash bg-alert mr-2"></i>
                        <span>VIDER MES DONNÉES LOCALES</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Security from '../../js/core/Security'
import Api from '../../js/core/Api'
import Config from "@/js/config";

export default {
    data() {
        return {
            email: '',
            password: '',
            urlSSO: Config.keycloak.url
        }
    },
    methods: {
        updateFront() {

            swal({
                title: 'Mise à jour',
                text: 'Mise à jour de l\'application effectué',
                type: 'info',
                showCancelButton: false,
                confirmButtonText: 'Ok',
            }).then(
                async () => {

                    let isNew = false;

                    if (window.flutter_inappwebview !== undefined) {
                        isNew = await window.flutter_inappwebview.callHandler('handlerIsNew');
                    }

                    if (window.isMobile() && isNew) {
                        window.wantReload();
                    }
                }
            )

        },

        clearCache() {

            swal({
                title: 'Attention',
                text: "Supprimer les données ? Tout ce que vous aurez saisi et pas synchronisé sera perdu",
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'NON',
                confirmButtonText: 'OUI'
            }).then(
                () => {
                    localforage
                        .clear()
                        .then(() => {
                            swal({
                                text: 'les données ont bien été supprimées',
                                type: 'success'
                            })
                        })
                },

                () => {
                    swal.close()
                }
            )
        },

        tryLogin(e) {

            if (typeof e !== 'undefined') {
                e.preventDefault();
            }

            let router = this.$router;
            let security = new Security;

            if (navigator.onLine) {
                if (this.email == "") {
                    this.email = document.getElementById('email').value;
                }

                if (this.password == "") {
                    this.password = document.getElementById('password').value;
                }

                security.login(this.email, this.password, (result) => {

                    if (result.status === true) {
                        if (window.isMobile() == true) {
                            if (typeof window.flutter_inappwebview !== 'undefined') {
                                window.flutter_inappwebview.callHandler('saveCredentials', this.email, this.password).then(() => {
                                    console.log('Credentials saved');
                                });
                            }
                        }

                        const redirectAfterLogin = () => {
                                const pending = sessionStorage.getItem('pendingRedirectAfterLogin');
                                if (pending) {
                                    sessionStorage.removeItem('pendingRedirectAfterLogin');
                                    router.push({ path: '/init', query: { redirect: pending } });
                                } else {
                                    router.push('init');
                                }
                            };


                        security.setUserSession(result.apiKey, function (res) {



                            if (res.status === true) {

                                Api
                                    .init()
                                    .then(api => {

                                        api
                                            .get('/messages')
                                            .then(res => {

                                                // TODO : AFFICHE LE MESSAGE ICI

                                                if (!res.data.errors && res.data.hasOwnProperty('messages') &&
                                                    res.data.messages.length !== 0 &&
                                                    !localStorage.getItem('msg-' + res.data.messages[0].id)) {

                                                    let message = res.data.messages[0];
                                                    let opt = {};

                                                    opt.title = message.title;

                                                    if (message.html) {
                                                        opt.html = message.message
                                                    } else {
                                                        opt.text = message.message
                                                    }

                                                    opt.type = message.type;

                                                    localStorage.setItem('msg-' + message.id, JSON.stringify(true));

                                                    swal(opt).then(() => redirectAfterLogin());

                                                } else {

                                                    redirectAfterLogin();

                                                }

                                            })
                                            .catch()

                                    })
                                    .catch()


                            } else {

                                swal('Erreur', "Erreur lors de l'initialisation de la session " + JSON.stringify(res.error), 'error')

                            }

                        })

                    } else {
                        swal('Erreur', result.error, 'error')
                    }

                })

            } else {

                if(localStorage.getItem('pwd') === this.password && localStorage.getItem('email') === this.email){

                    let now = moment().format();

                    const redirectAfterLogin = () => {
                        const pending = sessionStorage.getItem('pendingRedirectAfterLogin');
                        if (pending) {
                            sessionStorage.removeItem('pendingRedirectAfterLogin');
                            router.push({ path: '/init', query: { redirect: pending } });
                        } else {
                            router.push('home');
                        }
                    };

                    localforage
                        .setItem('lastConnexion', now)
                        .then(() => redirectAfterLogin())
                        .catch()

                } else {
                    swal('Erreur', 'Veuillez vous connecter à internet.', 'error')
                }
            }

        },

        getEmailIfExist() {
            localforage
                .getItem('profil')
                .then(res => {
                    if (res !== null) {
                        let usr = JSON.parse(res);
                        if (usr.hasOwnProperty('username') && usr.username !== '') {
                            this.email = usr.username
                        }
                    }
                })
                .catch()
        },
        b64DecodeUnicode(str) {
            // Going backwards: from bytestream, to percent-encoding, to original string.
            return decodeURIComponent(atob(str).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        },
        fillFields(mail, pswd) {
            this.email = mail;
            this.password = pswd;

            this.tryLogin();
        },
        launchAuth() {
            if (window.isMobile() == true) {
                if (typeof window.flutter_inappwebview !== 'undefined') {
                    window.flutter_inappwebview.callHandler('handlerGetCredentials').then((res) => {
                        if (res !== null) {
                            this.fillFields(res.email, res.password);
                        }
                    });

                }
            }
        },
        isMobile() {
            return window.isMobile();
        }

    },
    mounted() {
        if (!navigator.onLine) {
            swal('Erreur', 'Veuillez vous connecter à internet.', 'error')
        }

        this.getEmailIfExist();

    }
}

</script>



// WEBPACK FOOTER //
// Login.vue?790da819